import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Box from "@mui/material/Box";
import React, { useContext } from "react";

import { WorkspaceContext } from "@/models/StateProviders/workspaceProvider.tsx";
import MenuButton from "@/ui/MenuButton.tsx";

export default function WorkspaceDropdown() {
  const { currentWorkspaceId, workspaces } = useContext(WorkspaceContext);
  const activeWorkspace = workspaces?.find((ws) => ws.id === currentWorkspaceId);
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);

  if (!workspaces || workspaces?.length === 0 || !activeWorkspace) {
    return <div>loading...</div>;
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end", minWidth: 0 }}>
      {/* The picker sits at the right edge of the profile's account row, so its menu opens right-aligned. */}
      <MenuButton
        position="right"
        openState={(value) => setIsDropdownOpen(() => value)}
        element={
          <Box
            sx={{
              cursor: "pointer",
              py: 0.75,
              pl: 1.5,
              pr: 1,
              border: "1px solid var(--color-zinc-700)",
              borderRadius: 1,
              "&:hover": { background: "var(--color-zinc-800)" },
              display: "flex",
              alignItems: "center",
              gap: 1,
              minWidth: 0,
              color: "#fff",
              fontSize: "1rem",
            }}
          >
            <Box sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {activeWorkspace.name}
            </Box>
            {!isDropdownOpen ? <KeyboardArrowDownIcon fontSize="small" /> : <KeyboardArrowUpIcon fontSize="small" />}
          </Box>
        }
      >
        <Box
          sx={{
            py: 1,
            maxHeight: "66vh",
            overflowY: "auto",
          }}
        >
          {workspaces.map((ws) => (
            <Box
              key={ws.id}
              component="a"
              href={currentWorkspaceId === ws.id ? undefined : `/workspaces/${ws.id}/drivers`}
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                gap: 1,
                py: 1,
                px: 2,
                textDecoration: "none",
                ...(currentWorkspaceId === ws.id
                  ? { color: "var(--color-zinc-400)" }
                  : {
                      color: "#fff",
                      "&:hover": { bgcolor: "var(--color-zinc-700)" },
                    }),
              }}
            >
              <Box
                component="span"
                sx={{
                  textTransform: "uppercase",
                  border: "1px solid",
                  display: "flex",
                  py: 0.25,
                  px: 1,
                  width: "30px",
                  textAlign: "center",
                  borderRadius: 0.5,
                  borderColor: currentWorkspaceId === ws.id ? "var(--color-zinc-400)" : "#fff",
                }}
              >
                {ws.name[0]}
              </Box>
              <Box
                component="span"
                sx={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {ws.name}
              </Box>
            </Box>
          ))}
        </Box>
      </MenuButton>
    </Box>
  );
}
